import { render, staticRenderFns } from "./AulasTeoricasEnviadas.vue?vue&type=template&id=1fa908d5"
import script from "./AulasTeoricasEnviadas.vue?vue&type=script&lang=js"
export * from "./AulasTeoricasEnviadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports